import { createReducer } from 'store/createReducer';
import { VIDEOPLAYER_CLOSE, VIDEOPLAYER_OPEN, VideoAction } from './actions';

interface VideoState {
  title: string;
  id: string;
}
export const initialState: VideoState = {
  id: '',
  title: ''
};

export default createReducer<VideoState>(initialState, {
  [VIDEOPLAYER_OPEN]: (_, { id, title }: VideoAction) => ({ id, title }),
  [VIDEOPLAYER_CLOSE]: () => ({ id: '', title: '' })
});
